import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';
import React  from 'react';
import  useState  from 'react';



function FetchUsersForStores(token, profileId) {

    
    return axios.post(`${CURRENT_API_URL}/sellerPartner/FetchUsersForStoresV3FromUI`, {
        profileId: profileId,        
    }, {
        headers: {
            'Authorization': token,
        },
    }).then(res => {
        notify.NotifySuccess("Store users are getting fetched.");        
        return (res.data);
    }).catch(() => {
        notify.NotifyError("There was a problem while getting users for a selected store.");
        return false;
    });
}

export default FetchUsersForStores;